var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPin24 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.397 4.942a1.25 1.25 0 0 1 1.976-.277l3.897 3.897a1.25 1.25 0 0 1-.276 1.977l-3.384 1.88c-.094.051-.161.179-.13.328.372 1.763.054 3.06-.384 3.927-.217.43-.46.748-.653.96a3 3 0 0 1-.32.31l-.01.008-.013.011-.008.007-.003.002h-.002v.001l-.3-.4.3.4a.5.5 0 0 1-.654-.046l-1.582-1.582-4.243-4.242-1.6-1.6a.5.5 0 0 1 0-.707l.354.353-.354-.354.002-.001.002-.002.007-.007.022-.02q.027-.027.076-.07.098-.087.279-.226c.24-.18.59-.412 1.037-.622a5.75 5.75 0 0 1 3.74-.413c.168.037.304-.037.357-.133zm-5.975 9.803L5.67 18.11a.75.75 0 0 0 .05 1.005l.101.101a.75.75 0 0 0 1.005.05l3.364-2.752z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin24);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };